import { ColorContext } from 'App';
import React, { useContext } from 'react';
import { BsChevronBarLeft, BsChevronBarRight, BsChevronLeft, BsChevronRight } from 'react-icons/bs';

const PageIndex = ({ pageIndex, setPageIndex, maxPages }) => {
  const generatePageNumbers = () => {
    const pages = []; // Padding entries at the beginning
    for (
      let i = Math.max(1, pageIndex - 2);
      i <= Math.min(Math.ceil(maxPages), pageIndex + 2);
      i++
    ) {
      if (i > 0 || i > maxPages - 2) {
        pages.push(i);
      }
    }
    return pages;
  };

  const theme = useContext(ColorContext);

  return (
    <div
      className="d-flex justify-content-center gap-2 mt-3"
      style={{
        userSelect: 'none',
        color: theme.fontColor,
      }}
    >
      <div
        className="me-1"
        style={{
          opacity: pageIndex > 1 ? 1 : 0.2,
        }}
      >
        <button
          onClick={() => {
            if (pageIndex > 1) setPageIndex(1);
          }}
        >
          <BsChevronBarLeft />
        </button>
        <button
          onClick={() => {
            if (pageIndex > 1) setPageIndex(pageIndex - 1);
          }}
        >
          <BsChevronLeft />
        </button>
      </div>

      <div className="d-flex flex-row gap-2 justify-content-center min-w-25">
        {generatePageNumbers().map((page) => (
          <div
            className="text-center cursor-pointer"
            key={page}
            style={{
              opacity: page > 0 && page <= Math.ceil(maxPages) ? (page === pageIndex ? 1 : 0.5) : 0,
              fontWeight: page === pageIndex ? 'bold' : 'normal',
            }}
            onClick={() => page > 0 && page <= Math.ceil(maxPages) && setPageIndex(page)}
          >
            {page}
          </div>
        ))}
      </div>

      <div
        className="ms-1"
        style={{
          opacity: pageIndex < Math.ceil(maxPages) ? 1 : 0.2,
        }}
      >
        <button
          onClick={() => {
            if (pageIndex < Math.ceil(maxPages)) setPageIndex(pageIndex + 1);
          }}
        >
          <BsChevronRight />
        </button>
        <button
          onClick={() => {
            if (pageIndex < Math.ceil(maxPages)) setPageIndex(Math.floor(Math.ceil(maxPages)));
          }}
        >
          <BsChevronBarRight />
        </button>
      </div>
    </div>
  );
};

export default PageIndex;
